/**
 * Lets map-level code lower the mobile bottom drawer.
 *
 * The drawer (`components/ContentDrawer`) is rendered by each page rather than by
 * MapLayout, and owns its own open / half-open / closed state, so there is no prop
 * path from the map controls down to it. This is a one-shot pub/sub rather than
 * Redux state because the request is momentary — "get out of the way now" — with
 * nothing to keep or restore afterwards.
 */

const listeners = new Set();

/**
 * Ask the mounted drawer to drop to its handle so the map is visible.
 * No-op when no drawer is listening (desktop renders its content inline).
 */
export function collapseDrawer() {
	listeners.forEach((listener) => listener());
}

/**
 * @param {() => void} handler called on every collapse request
 * @returns {() => void} unsubscribe
 */
export function subscribeToCollapseDrawer(handler) {
	listeners.add(handler);
	return () => {
		listeners.delete(handler);
	};
}

const drawerControl = { collapseDrawer, subscribeToCollapseDrawer };

export default drawerControl;
